import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { Alert, Button, Result, Space, Typography } from "antd";
import { CheckCircleOutlined, SendOutlined } from "@ant-design/icons";
import { SubmitAccessRequest } from "../services/ApiService";

const { Text } = Typography;

function NoAccess({ message }) {
  const auth = useAuth();
  const token = auth?.user?.id_token;
  const email = auth?.user?.profile?.email;

  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const handleRequest = async () => {
    setStatus("loading");
    try {
      await SubmitAccessRequest(token);
      setStatus("success");
    } catch (e) {
      setErrorMsg(e.message || "Failed to submit request.");
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <Result
        icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
        title="Access Request Submitted"
        subTitle={
          <>
            Your request for <Text strong>{email}</Text> has been sent to the administrator.
            You will be notified once your access is approved.
          </>
        }
        extra={
          <Button onClick={() => auth.signoutRedirect()}>Sign Out</Button>
        }
      />
    );
  }

  return (
    <Result
      status="403"
      title="Access Denied"
      subTitle={
        <Space direction="vertical" align="center">
          <span>{message || "You do not have permission to access this tool."}</span>
          {email && <Text type="secondary">Signed in as: <Text strong>{email}</Text></Text>}
          {status === "error" && <Alert type="error" message={errorMsg} showIcon />}
        </Space>
      }
      extra={
        <Space>
          <Button
            type="primary"
            icon={<SendOutlined />}
            loading={status === "loading"}
            onClick={handleRequest}
          >
            Request Access
          </Button>
          <Button onClick={() => auth.signoutRedirect()}>Sign Out</Button>
        </Space>
      }
    />
  );
}

export default NoAccess;
